import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Stats() {
  const [stats, setStats] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/clicks/count`)
      .then((res) => setStats(res.data))
      .catch(() => setFailed(true));
  }, []);

  return (
    <main
      data-testid="stats-page"
      className="relative z-10 mx-auto flex min-h-screen w-full max-w-2xl flex-col items-center justify-center gap-10 px-6 text-center"
    >
      <p className="text-xs font-bold uppercase tracking-[0.35em] text-[#4A4D7A]">
        Checklist CTA clicks
      </p>
      {failed ? (
        <p data-testid="stats-error" className="text-sm text-[#B3261E]">
          Could not load stats.
        </p>
      ) : !stats ? (
        <p className="text-sm text-[#4A4D7A]">Loading…</p>
      ) : (
        <div className="flex items-start justify-center gap-16 md:gap-24">
          <div className="flex flex-col items-center gap-2">
            <span
              data-testid="stats-total"
              className="font-display text-6xl font-bold uppercase leading-none md:text-7xl"
            >
              {stats.total}
            </span>
            <span className="text-xs uppercase tracking-[0.25em] text-[#4A4D7A]">
              All time
            </span>
          </div>
          <div className="flex flex-col items-center gap-2">
            <span
              data-testid="stats-today"
              className="font-display text-6xl font-bold uppercase leading-none md:text-7xl"
            >
              {stats.today}
            </span>
            <span className="text-xs uppercase tracking-[0.25em] text-[#4A4D7A]">
              Today
            </span>
          </div>
        </div>
      )}
      <a
        data-testid="stats-back-link"
        href="/"
        className="text-xs font-bold uppercase tracking-[0.25em] text-[#1A1F5E] underline-offset-4 transition-colors duration-300 hover:text-[#4A4D7A] hover:underline"
      >
        ← Back to page
      </a>
    </main>
  );
}
